import { useMutation, useQueryClient } from "@tanstack/react-query";
import { logout as persistLogout } from "../../services/auth";
import { useAuth } from "../../contexts/AppContext";

export const useLogout = () => {
  const queryClient = useQueryClient();
  const { setLoggedIn, setLoading, setError, setClientData } = useAuth();

  return useMutation<void, unknown, void>({
    mutationFn: async () => {
      // Limpa o localStorage
      persistLogout();
    },
    onSuccess: () => {
      // Atualiza o contexto de autenticação
      setLoggedIn(false);
      setLoading(false);
      setError(null);
      setClientData(null);

      // Limpa todo o cache do React Query
      queryClient.clear();

      // Redireciona para a página de login
      window.location.href = "/centraleconexao";
    },
    onError: () => {
      // Mesmo em caso de erro, tenta limpar
      persistLogout();
      setError("Não foi possível sair");
      setLoading(false);
      setLoggedIn(false);
      setClientData(null);
      queryClient.clear();

      // Redireciona para a página de login mesmo em caso de erro
      window.location.href = "/centraleconexao";
    },
  });
};
